// extracted by mini-css-extract-plugin
module.exports = {"cover":"__1O1JtP_I","lazyimg":"lm0qFiMd","ratioSpan":"__15nUKRzR"};